import { render, staticRenderFns } from "./MADDs.vue?vue&type=template&id=64ea819a&scoped=true"
import script from "./MADDs.vue?vue&type=script&lang=js"
export * from "./MADDs.vue?vue&type=script&lang=js"
import style0 from "./MADDs.vue?vue&type=style&index=0&id=64ea819a&lang=scss&scoped=true"
import style1 from "./MADDs.vue?vue&type=style&index=1&id=64ea819a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea819a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ea819a')) {
      api.createRecord('64ea819a', component.options)
    } else {
      api.reload('64ea819a', component.options)
    }
    module.hot.accept("./MADDs.vue?vue&type=template&id=64ea819a&scoped=true", function () {
      api.rerender('64ea819a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Tabs/MADDs.vue"
export default component.exports